import type { NotificationType } from '@/modules/Notification/types/model'

export interface NotificationIconConfig {
  icon: string
  iconColor: string
  backgroundColor: string
}

export const NOTIFICATION_ICON_CONFIG: Record<
  NotificationType,
  NotificationIconConfig
> = {
  letter: {
    icon: 'secretariat',
    iconColor: '#9333EA',
    backgroundColor: '#F3E8FF',
  },
  announcement: {
    icon: 'promotion',
    iconColor: '#DC2626',
    backgroundColor: '#FEE2E2',
  },
  employmentForm: {
    icon: 'userViewfinder',
    iconColor: '#0D9488',
    backgroundColor: '#CCFBF1',
  },
  course: {
    icon: 'graduationCap',
    iconColor: '#2563EB',
    backgroundColor: '#DBEAFE',
  },
  assessment: {
    icon: 'fileSearch',
    iconColor: '#9333EA',
    backgroundColor: '#F3E8FF',
  },
  reminder: {
    icon: 'calendarClock',
    iconColor: '#DC2626',
    backgroundColor: '#FEE2E2',
  },
  employmentApproved: {
    icon: 'userViewfinder',
    iconColor: '#0D9488',
    backgroundColor: '#CCFBF1',
  },
  newUser: {
    icon: 'notification',
    iconColor: '#2563EB',
    backgroundColor: '#DBEAFE',
  },
  manual: {
    icon: 'notification',
    iconColor: '#2563EB',
    backgroundColor: '#DBEAFE',
  },
}
